

























































































import { Component } from 'vue-property-decorator';
import ServiceProvidersFilter from "@/components/Settings/ServiceProviders/ServiceProvidersFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {Getter} from "vuex-class";
import {ServiceProviderItem} from "@/store/settings/service_providers/types";
import PartnersFilter from "@/components/Settings/Partners/PartnersFilter.vue";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";

@Component({components:{PartnersFilter, ServiceProvidersFilter,ScrollButton}})
export default class ServiceProviders extends BaseItemsPage<ServiceProviderItem> {
  @Getter("serviceProviders") serviceProvidersResponse: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";

  tableFields = [
    'name',
    'transport_names',
    'status',
  ];

  getData(): any {
    return this.serviceProvidersResponse;
  }
}
